/* Predictive search — client-side fuzzy op products-flat.json
 * Activeert zodra de search-modal opengaat en er in #search-input wordt getypt.
 */

(function () {
  const input = document.getElementById('search-input');
  const resultsBox = document.getElementById('search-results');
  const form = document.querySelector('[data-search-form]');
  if (!input || !resultsBox) return;

  let products = null;
  let loading = false;

  // Synoniemen om NL zoekgedrag beter te vangen
  const SYNONYMS = {
    'kraan': ['kranen', 'mengkraan', 'badkraan', 'douchekraan'],
    'mengkraan': ['kraan', 'kranen'],
    'zwart': ['mat zwart', 'matzwart'],
    'goud': ['geborsteld goud', 'gouden'],
    'koper': ['geborsteld koper'],
    'wc': ['toilet', 'hangtoilet', 'hangend'],
    'toilet': ['wc', 'hangtoilet'],
    'bad': ['ligbad', 'vrijstaand bad', 'whirlpool'],
    'douche': ['regendouche', 'douchekop', 'douchecabine'],
    'wastafel': ['waskom', 'fontein'],
    'spiegel': ['spiegels', 'led-spiegel'],
    'meubel': ['onderkast', 'wastafelmeubel', 'kolomkast'],
  };

  function expandQuery(q) {
    const words = q.toLowerCase().trim().split(/\s+/).filter(Boolean);
    const expanded = new Set(words);
    words.forEach(w => (SYNONYMS[w] || []).forEach(s => expanded.add(s)));
    return [...expanded];
  }

  let subcollections = null;
  async function loadProducts() {
    if (products || loading) return;
    loading = true;
    try {
      const [pRes, sRes] = await Promise.all([
        fetch('/data/products-flat.json'),
        fetch('/data/subcollections.json').catch(() => null),
      ]);
      products = await pRes.json();
      if (sRes && sRes.ok) {
        const data = await sRes.json();
        subcollections = [];
        for (const col of data) {
          for (const sub of col.subs) {
            if (sub.slug === 'overig') continue;
            subcollections.push({
              title: sub.title,
              count: sub.count,
              href: `/collections/${col.parent}/${sub.slug}/`,
              parent: col.parent_title || col.parent,
              search: (sub.title + ' ' + col.parent).toLowerCase(),
            });
          }
        }
      }
    } catch (e) { products = []; }
    loading = false;
  }

  function findMatchingSubs(tokens) {
    if (!subcollections) return [];
    return subcollections
      .map(s => {
        let hits = 0;
        for (const t of tokens) {
          if (!t) continue;
          if (s.search.includes(t)) hits++;
        }
        return { s, hits };
      })
      .filter(x => x.hits > 0)
      .sort((a, b) => b.hits - a.hits || b.s.count - a.s.count)
      .slice(0, 4)
      .map(x => x.s);
  }

  function score(product, tokens) {
    const title = (product.title || '').toLowerCase();
    const brand = (product.brand || '').toLowerCase();
    const tags = (product.tags || '').toLowerCase();
    const colors = (product.colors || []).join(' ').toLowerCase();
    const materials = (product.materials || []).join(' ').toLowerCase();
    let s = 0;
    for (const t of tokens) {
      if (!t) continue;
      if (title.startsWith(t)) s += 100;
      if (title.includes(t)) s += 50;
      if (brand.includes(t)) s += 40;
      if (colors.includes(t)) s += 30;
      if (materials.includes(t)) s += 30;
      if (tags.includes(t)) s += 20;
    }
    return s;
  }

  function renderEmpty() {
    resultsBox.innerHTML = `
      <p class="tracking-editorial text-[color:var(--muted)] mb-6">Populair</p>
      <div class="flex flex-wrap gap-3">
        <a href="/collections/kranen/" class="px-5 py-2.5 rounded-full bg-[color:var(--paper)] hover:bg-[color:var(--oak)] hover:text-ink transition text-[14px]">Badmengkranen</a>
        <a href="/collections/badkamermeubels/" class="px-5 py-2.5 rounded-full bg-[color:var(--paper)] hover:bg-[color:var(--oak)] hover:text-ink transition text-[14px]">Wastafelmeubels</a>
        <a href="/collections/spiegels/" class="px-5 py-2.5 rounded-full bg-[color:var(--paper)] hover:bg-[color:var(--oak)] hover:text-ink transition text-[14px]">LED-spiegels</a>
        <a href="/collections/douche/" class="px-5 py-2.5 rounded-full bg-[color:var(--paper)] hover:bg-[color:var(--oak)] hover:text-ink transition text-[14px]">Regendouches</a>
        <a href="/collections/radiatoren/" class="px-5 py-2.5 rounded-full bg-[color:var(--paper)] hover:bg-[color:var(--oak)] hover:text-ink transition text-[14px]">Handdoekradiatoren</a>
        <a href="/collections/toiletten/" class="px-5 py-2.5 rounded-full bg-[color:var(--paper)] hover:bg-[color:var(--oak)] hover:text-ink transition text-[14px]">Hangtoiletten</a>
      </div>`;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderNoHits(query) {
    resultsBox.innerHTML = `
      <div class="py-10 text-center">
        <p class="tracking-editorial text-[color:var(--muted)] mb-3">Geen resultaten</p>
        <p class="text-[16px] text-ink max-w-[420px] mx-auto">Geen producten gevonden voor &laquo;${escapeHtml(query)}&raquo;. Probeer een ander woord of blader door de <a href="/collections/all/" class="underline hover:text-[color:var(--moss)]">volledige collectie</a>.</p>
      </div>`;
  }

  function renderResults(hits, query, subHits) {
    subHits = subHits || [];
    const subSection = subHits.length ? `
      <div class="mb-6 pb-5 border-b border-[color:var(--line)]">
        <p class="tracking-editorial text-[color:var(--muted)] mb-3">Categorieën</p>
        <div class="flex flex-wrap gap-2">
          ${subHits.map(s => `<a href="${s.href}" class="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[color:var(--line)] hover:border-ink hover:bg-ink hover:text-bone transition text-[13px]"><span>${s.title}</span><span class="text-[color:var(--muted)] group-hover:text-bone/70">${s.count}</span></a>`).join('')}
        </div>
      </div>` : '';

    const fallbackChips = [
      ['Badmengkranen', '/collections/kranen/badkranen/'],
      ['Wastafelmeubels', '/collections/badkamermeubels/wastafelonderkasten/'],
      ['LED-spiegels', '/collections/spiegels/led-spiegels/'],
    ];
    const suggestHTML = (subHits.length ? [] : fallbackChips).map(([label, href]) => `
      <a href="${href}" class="px-4 py-2 rounded-full bg-[color:var(--paper)] hover:bg-[color:var(--oak)] hover:text-ink transition text-[13px]">${label}</a>
    `).join('');

    resultsBox.innerHTML = `
      ${subSection}
      <div class="flex items-center justify-between mb-5">
        <p class="tracking-editorial text-[color:var(--muted)]">${hits.length} ${hits.length === 1 ? 'resultaat' : 'resultaten'}</p>
        <a href="/collections/all/?q=${encodeURIComponent(query)}" class="text-[13px] text-[color:var(--moss)] hover:text-ink link-draw">Alle resultaten &rarr;</a>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        ${hits.slice(0, 8).map(p => `
          <a href="/products/${p.handle}/" class="flex items-center gap-4 p-3 rounded-xl hover:bg-[color:var(--paper)] transition group">
            <div class="w-16 h-16 shrink-0 rounded-lg overflow-hidden bg-[color:var(--paper)] p-1.5">
              <img src="${p.image}" alt="" class="w-full h-full object-contain" loading="lazy" />
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-[11px] tracking-[0.15em] uppercase text-[color:var(--muted)]">${p.brand || ''}</p>
              <p class="text-[14px] font-medium text-ink truncate">${p.title}</p>
              ${p.compare_at && p.compare_at > p.price
                ? `<p class="text-[13px]"><span class="text-[color:var(--muted)] line-through mr-1.5">€${p.compare_at.toFixed(0)}</span><span class="text-ink font-medium">€${p.price.toFixed(0)}</span></p>`
                : `<p class="text-[13px] text-[color:var(--ink-soft)]">€${p.price.toFixed(0)}</p>`}
            </div>
            <svg class="w-4 h-4 text-[color:var(--muted)] shrink-0 group-hover:translate-x-0.5 group-hover:text-ink transition" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
          </a>
        `).join('')}
      </div>
      <div class="mt-8 pt-5 border-t border-[color:var(--line)]">
        <p class="tracking-editorial text-[color:var(--muted)] mb-3">Suggesties</p>
        <div class="flex flex-wrap gap-2">${suggestHTML}</div>
      </div>`;
  }

  let debounceTimer;
  function onInput(e) {
    const q = e.target.value.trim();
    clearTimeout(debounceTimer);
    if (!q) { renderEmpty(); return; }
    debounceTimer = setTimeout(async () => {
      await loadProducts();
      if (!products || !products.length) { renderEmpty(); return; }
      const tokens = expandQuery(q);
      const scored = products
        .map(p => ({ p, s: score(p, tokens) }))
        .filter(x => x.s > 0)
        .sort((a, b) => b.s - a.s)
        .map(x => x.p);
      const subHits = findMatchingSubs(tokens);
      if (!scored.length && !subHits.length) renderNoHits(q);
      else renderResults(scored, q, subHits);
    }, 120);
  }

  input.addEventListener('input', onInput);
  input.addEventListener('focus', loadProducts, { once: true });

  // Submit → navigate to /collections/all/?q=… for full results
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const q = input.value.trim();
      if (q) {
        try { window.Analytics && Analytics.search(q); } catch (_) {}
        location.href = '/collections/all/?q=' + encodeURIComponent(q);
      }
    });
  }
})();
